// import ReactPaginate from "react-paginate"

import Breadcrumbs from "../Breadcrumbs/Breadcrumbs"
import styles from "./List.module.scss"
// import pStyles from "./Pagination.module.scss"
import InsightItem from "../Insights/InsightItem"
import { useState, useEffect } from "react"

export default function List({ items }) {
  return (
    <section className={styles.list}>
      <Breadcrumbs
        className={styles.list__breadcrumbs}
        items={[{ name: "Insights" }]}
      ></Breadcrumbs>
      <h1>Horizon Insights</h1>

      <ul className={`${styles.list__items}`}>
        {items.map((item, index) => {
          return (
            <li className={styles.list__item} key={index}>
              <InsightItem
                postsPage
                key={index}
                item={item}
                index={index}
                className={styles.videos__item}
              />
            </li>
          )
        })}
      </ul>
    </section>
  )
}
